import {
  Component,
  ElementRef,
  Input,
  output,
  contentChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { BannerType, CreativeAlignment } from './m-banner.component.types';
import { NgStyle, NgClass } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-banner',
  templateUrl: './m-banner.component.html',
  styleUrls: ['./m-banner.component.scss'],
  imports: [NgStyle, NgClass]
})
export class MBannerComponent {
  readonly contentChild = contentChild<ElementRef>('creative');

  @Input() type: BannerType = BannerType.primary;
  @Input() title = '';
  @Input() subText = '';
  @Input() creativePlacement: 'first' | 'last' | 'hidden' = 'last';
  @Input() creativeAlignment: CreativeAlignment = CreativeAlignment.bottom;
  @Input() closeable = true;
  readonly closeBanner = output<void>();

  public handleBannerClose() {
    this.closeBanner.emit();
  }
}
